// src/components/dema/CompanyDetails.tsx
import React from "react";
import CompanyFilters from "./CompanyFilters";
import CompetitorCardWithAccess from "../misc/CompetitorCardWithAccess";
import { CompanyDetailsProps } from "../../types/interfaces";
import { mapSimilarCompanyToCompetitorData } from "../../utils/mapCompany";

const CompanyDetails: React.FC<CompanyDetailsProps> = ({
  detailsData,
  searchName,
  setSearchName,
  searchLocation,
  setSearchLocation,
  employeeRange,
  setEmployeeRange,
  locationOptions,
}) => {
  return (
    <div className="text-white">
      <CompanyFilters
        searchName={searchName}
        setSearchName={setSearchName}
        searchLocation={searchLocation}
        setSearchLocation={setSearchLocation}
        employeeRange={employeeRange}
        setEmployeeRange={setEmployeeRange}
        locationOptions={locationOptions}
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-8">
        {detailsData.companies.map((comp, idx) => {
          const competitorData = mapSimilarCompanyToCompetitorData(comp, comp.similarity);
          return <CompetitorCardWithAccess key={idx} competitor={competitorData} />;
        })}
      </div>
    </div>
  );
};

export default CompanyDetails;
